import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@printdeal/ui-library';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface OrderTotalProps {
  order: SanitizedOrder;
}

const OrderTotal = ({
  order,
}: OrderTotalProps) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  return (
    <div className="pd-flex pd-gap-x-4">
      <div className="pd-flex pd-grow pd-flex-col pd-gap-x-4 lg:pd-flex-row">
        <Heading variant="display" size="2" as="div" className="pd-w-full lg:pd-w-48">
          <FormattedMessage
            id="account.order.payment.total.title"
            defaultMessage="Payment total"
          />
        </Heading>
        <Heading variant="display" size="2" as="div" className="pd-w-full pd-grow lg:pd-w-48">
          <FormattedMessage id="general.totalAmount.includingVat" defaultMessage="Incl. VAT" />
        </Heading>
      </div>
      <Heading variant="display" size="2" as="span">
        <Money
          value={entityTotal?.totalPrice.totalGross.centAmount ?? 0}
          currency={entityTotal?.totalPrice.totalGross.currencyCode}
        />
      </Heading>
    </div>
  );
};

export default OrderTotal;
